import { parseUrlParts } from '../workArea/parseUrl';
/**
 * Converts a PrdssSetting to a common Connection.
 * @internal
 */
export function toConnection(connection) {
    const urlParts = parseUrlParts(connection.properties.Url || connection.properties.ConnectionUrl);
    return {
        ...connection.properties,
        ConnectionUrl: urlParts.connectionUrl,
        DatasourceId: urlParts.datasourceId,
        ServerUrl: urlParts.serverUrl,
        Url: urlParts.connectionUrl
    };
}
/**
 * Converts a common Connection to a PrdssSetting.
 * @internal
 */
export function toPrdssSetting(connection) {
    return {
        name: connection.Id,
        namespace: 'datasources',
        properties: {
            Description: connection.Description,
            Id: connection.Id,
            Name: connection.Name,
            Type: connection.Type,
            UIUrl: connection.UIUrl,
            Url: connection.Url || connection.ConnectionUrl,
            WorkAreaName: connection.WorkAreaName
        }
    };
}
